export enum IntegrationType {
  Flood = 'Flood',
  LOS = 'Los',
  Underwrite = 'Underwrite',
  Credit = 'Credit',
  VOA = 'VOA',
  VOIE = 'VOIE',
  Title = 'Title',
  PropertyData = 'PropertyData',
  Fees = 'Fees',
  Pricing = 'Pricing',
}

export enum IntegrationVendor {
  None = 'None',
  Factual = 'Factual',
  Xactus = 'Xactus',
  InformativeResearch = 'InformativeResearch',
  MeridianLink = 'MeridianLink',
  FreddieMac = 'FreddieMac',
  FannieMae = 'FannieMae',
  RatesBoard = 'RatesBoard',
  Flueid = 'Flueid',
  Vesta = 'Vesta',
  Resend = 'Resend',
  Snap = 'Snap',
  Truv = 'Truv',
  Equifax = 'Equifax',
  Truework = 'Truework',
  Argyle = 'Argyle',
  Ernst = 'Ernst',
  SmartFees = 'SmartFees',
  Experian = 'Experian',
}

export enum IntegrationStatus {
  Unknown,
  Active,
  Unverified,
  Disabled,
}
